import { currency, currencySymbol } from 'filters';
import moment from 'moment';

export default {
  keys: [
    {
      title: '일자',
      key: 'paidAt',
      column: 'paidAt',
      orderKey: 'paidAt',
      order: 'desc',
      // dateFormat: 'YYYY-MM-DD',
      columnGroup: false,
      filter: (o) => {
        if (o !== undefined) {
          return `<div><span>${moment(o.paidAt).format(
            'YYYY-MM-DD'
          )}</span></div>`;
        }
      },
    },
    {
      title: '일간 매출액',
      key: 'totalAmount',
      column: 'totalAmount',
      columnGroup: false,
      filter: (o) => {
        return `${currencySymbol()} ${currency((o || {}).totalAmount || 0)}`;
      },
    },
    {
      title: '일간 수납액',
      columnGroup: true,
      columnItems: [
        { title: '합계', key: 'paidAmount', filter: { type: 'amount' } },
        { title: '카드', key: 'cardAmount', filter: { type: 'amount' } },
        {
          title: '계좌이체',
          key: 'bankTransferAmount',
          filter: { type: 'amount' },
        },
        { title: '현금', key: 'cashAmount', filter: { type: 'amount' } },
      ],
    },
    {
      title: '일간 미수액',
      key: 'unpaidAmount',
      column: 'unpaidAmount',
      columnGroup: false,
      filter: (o) => {
        return `${currencySymbol()} ${currency((o || {}).unpaidAmount || 0)}`;
      },
    },
    {
      title: '일간 환불액',
      key: 'refundAmount',
      column: 'refundAmount',
      columnGroup: false,
      filter: (o) => {
        return `${currencySymbol()} ${currency((o || {}).refundAmount || 0)}`;
      },
    },
  ],
};
